export const getUserInfo = async (sendAndWaitWs) => {
  const request = {};
  const response = await sendAndWaitWs("/user/get", JSON.stringify(request));
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};

export const saveUserSetting = async (sendAndWaitWs, setting) => {
  const response = await sendAndWaitWs(
    "/user/setting/save",
    JSON.stringify(setting)
  );
  if (response.error) {
    return response.error;
  }
  return JSON.parse(response.payload);
};
